module.exports = __webpack_public_path__ + "img/apple-pay.3b0655b.svg";